import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

export const DeleteConfirmDialog = ({ 
  deleteConfirm, 
  onConfirm, 
  onCancel 
}) => {
  const getDialogMessage = () => {
    const { type, name } = deleteConfirm;
    switch (type) {
      case 'user':
        return <>Are you sure you want to delete <strong>{name}</strong>? This will also delete all their reviews.</>;
      case 'review':
        return <>Are you sure you want to delete the review for <strong>{name}</strong>?</>;
      case 'bulk-users':
        return <>Are you sure you want to delete <strong>{name}</strong>? This will also delete all their reviews.</>;
      case 'bulk-reviews':
        return <>Are you sure you want to delete <strong>{name}</strong>?</>;
      case 'bulk-discrete-alerts':
        return <>Are you sure you want to delete <strong>{name}</strong>? This action cannot be undone.</>;
      case 'bulk-alert-logs':
        return <>Are you sure you want to delete <strong>{name}</strong>? This action cannot be undone.</>;
      case 'bulk-clear-redflags':
        return <>Are you sure you want to re-enable alerts for <strong>{name}</strong>? Their red flag status will be cleared.</>;
      default:
        return <>Are you sure you want to proceed?</>;
    }
  };

  const getButtonText = () => {
    if (deleteConfirm.type === 'bulk-clear-redflags') {
      return 'Re-Enable';
    }
    return 'Delete';
  };

  return (
    <Dialog open={deleteConfirm.show} onOpenChange={(open) => !open && onCancel()}>
      <DialogContent className="bg-white border-4 border-black max-w-md">
        <DialogHeader>
          <DialogTitle 
            className="text-2xl text-red-600 font-bold"
            style={{ fontFamily: 'Bebas Neue, sans-serif', letterSpacing: '2px' }}
          >
            Confirm {deleteConfirm.type === 'bulk-clear-redflags' ? 'Action' : 'Delete'}
          </DialogTitle>
          <DialogDescription className="text-gray-700 text-base mt-2">
            {getDialogMessage()}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="mt-6 flex gap-3">
          <Button
            type="button"
            variant="outline"
            onClick={onCancel}
            className="border-2 border-black"
          >
            Cancel
          </Button>
          <Button
            type="button"
            onClick={onConfirm}
            className={`${deleteConfirm.type === 'bulk-clear-redflags' ? 'bg-green-600 hover:bg-green-700' : 'bg-red-600 hover:bg-red-700'} text-white border-2 border-black`}
          >
            {getButtonText()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
